<icc-select-box [title]="'ROLLER_SHUTTER_LEGACY|System' | translate"
  [description]="(selectedSystem$ | async)?.name"
  [imageUrl]="'/files/rollershuttersystem/' + ((selectedSystem$ | async)?.image || '')"
  [buttonText]="'INTERFACE|Zmień' | translate"
  (select)="changeSystem()"
></icc-select-box>

@if ((selectedConfiguratorType$ | async) === 'external_blind') {
  <icc-select-box
    [title]="'ROLLER_SHUTTER_LEGACY|Typ pancerza:' | translate"
    [description]="(profile$ | async)?.name"
    [imageUrl]="'/files/profile/' + ((profile$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeProfile()"
  ></icc-select-box>
}

@if (mosquito$ | async) {
  <div id="mosquito-form" class="mat-elevation-z3">
    <form>
      <h4>{{ 'ROLLER_SHUTTER_LEGACY|Siatka antyinsektowa:' | translate }}</h4>
      @if (this.showDimensionSizeRange) {
        <h6>
          <p>
            {{ 'ROLLER_SHUTTER_LEGACY|Zakres szerokości rolety:' | translate }} {{mosquitoSizeRange['minWidth']}} - {{mosquitoSizeRange['maxWidth']}}
          </p>
          <p>
            {{ 'ROLLER_SHUTTER_LEGACY|Zakres wysokości rolety:' | translate }} {{mosquitoSizeRange['minHeight']}} - {{mosquitoSizeRange['maxHeight']}}
          </p>
        </h6>
      }
      @for (shutter of (shutters$ | async); track shutter; let index = $index) {
        <mat-checkbox [name]="'shutter-mosquito-' + index" [ngModel]="shutter.mosquito"  (ngModelChange)="toggleMosquito($event, index)">
          {{ 'WINDOW|Kwatera' | translate }} {{letters[index]}}
        </mat-checkbox>
      }
    </form>
  </div>
}
